import { Button } from "primereact/button";
import { Chips } from "primereact/chips";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useRef, useState } from "react";
import { FileUploader, FileUploaderRef } from "../FileUploader";
import { FileDialogProps, validateTags } from "./FileDialogWrapper";

export default function CompanyFileUploadDialog(props: FileDialogProps) {
  const uploadRef = useRef<FileUploaderRef>() as React.MutableRefObject<FileUploaderRef>;

  const isEdit = !!props.currentFile?.id;

  const [fileName, setFileName] = useState<string>(() => props.currentFile?.fileName ?? "");
  const [fileTags, setFileTags] = useState<string[]>(() => props.currentFile?.tags ?? []);
  const [desc, setDesc] = useState<string>(() => props.currentFile?.description ?? "");

  const [locked, setLocked] = useState(false);

  useEffect(() => {
    setFileName(props.currentFile?.fileName ?? "");
    setFileTags(props.currentFile?.tags ?? []);
    setDesc(props.currentFile?.description ?? "");
  }, [props.currentFile]);

  const upload = () => {
    console.warn("upload", desc, fileTags);
    validateTags(fileTags);

    setLocked(true);
    uploadRef.current!!.upload();
  };

  const clearForm = () => {
    setFileName("");
    setFileTags([]);
    setDesc("");
    setLocked(false);
  };

  const closeDialog = () => {
    props.setVisible(false);
    clearForm();
  };

  const onErrored = () => {
    setLocked(false);
  };

  const onFileChange = (file: File) => {
    console.log("onFileChange", file);
  };

  return (
    <Dialog
      header={`File ${isEdit ? "edit" : "upload"}`}
      visible={props.visible}
      style={{ maxWidth: "500px" }}
      modal
      onHide={closeDialog}
    >
      <div className="p-fluid p-formgrid p-grid">
        {/* ===== Table selection ======= */}
        <div className="p-field p-col-12">
          <label>File</label>
          <FileUploader
            ref={uploadRef}
            isEdit={isEdit}
            isPublic={false}
            id={props.currentFile?.id}
            onSelected={onFileChange}
            fileName={fileName}
            desc={desc}
            fileTags={fileTags}
            onUploaded={closeDialog}
            onErrored={onErrored}
          />
        </div>

        {/* file name */}
        <div className="p-field p-col-12">
          <label>File Name</label>
          <InputText value={fileName} onChange={e => setFileName(e.target.value)} />
        </div>

        {/* description */}
        <div className="p-field p-col-12">
          <label>Description</label>
          <InputText value={desc} onChange={e => setDesc(e.target.value)} />
        </div>

        {/* tags */}
        <div className="p-field p-col-12">
          <label>Tags</label>
          <Chips value={fileTags} onChange={e => setFileTags(e.value)} />
        </div>

        <div className="flex flex-auto gap-5 justify-content-center">
          <Button
            label="Submit"
            icon="pi pi-upload"
            className="p-button-success"
            onClick={upload}
            disabled={locked}
            style={{ width: "200px" }}
          />
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-danger"
            onClick={upload}
            disabled={locked}
            style={{ width: "200px" }}
          />
        </div>
      </div>
    </Dialog>
  );
}
